// Room-by-room "Make it home" matched bundles for the completion / Love
// Living moment. Each room is a MatchedProjectBundle config: one picked
// product per need across the right department/category, with Swap. Needs
// carry their own `department` because a room pulls across departments
// (e.g. a living room = Furniture sofa + Lighting & Decor rug/light/decor).

export const ROOM_BUNDLES = {
  living: {
    key: 'living',
    label: 'Living room',
    title: 'A living room, matched for you',
    intro: "A lounge, rug, light and a finishing piece gathered across our retailers into one starting point. Swap any piece — you buy each one direct from the retailer.",
    seeAll: { to: '/products/furniture', label: "See more living room products we've matched" },
    needs: [
      { label: 'Sofa or lounge', department: 'furniture', cat: 'living-furniture', prefer: ['sofa', 'lounge', 'couch', 'armchair', 'modular'], avoid: ['cover', 'part', 'outdoor', 'cushion'] },
      { label: 'Rug', department: 'lighting-decor', cat: 'rugs-flooring', prefer: ['rug'], avoid: ['underlay', 'gripper', 'tile'] },
      { label: 'Lighting', department: 'lighting-decor', cat: 'lighting-indoor', prefer: ['floor lamp', 'table lamp', 'pendant', 'lamp'], avoid: ['bulb', 'globe', 'spare', 'part'] },
      { label: 'Finishing touch', department: 'lighting-decor', cat: 'home-decor', prefer: ['cushion', 'throw', 'vase', 'wall art', 'mirror'], avoid: ['sample', 'swatch'] },
    ],
  },
  bedroom: {
    key: 'bedroom',
    label: 'Bedroom',
    title: 'A bedroom, matched for you',
    intro: "Start with a good night's sleep, then the bed, bedside and linen around it — gathered into one matched set. Swap any piece; you buy each one direct.",
    seeAll: { to: '/products/bedroom-sleep', label: "See more bedroom products we've matched" },
    needs: [
      { label: 'Bed', department: 'furniture', cat: 'bedroom-furniture', prefer: ['bed frame', 'bed base', 'ensemble', 'bed'], avoid: ['bedside', 'drawer', 'tallboy', 'side table', 'mattress'] },
      { label: 'Sleep on', department: 'bedroom-sleep', cat: 'bedroom-sleep', prefer: ['mattress', 'quilt', 'pillow'], avoid: ['protector only', 'topper only'] },
      { label: 'Bedside', department: 'furniture', cat: 'bedroom-furniture', prefer: ['bedside', 'drawer', 'tallboy', 'nightstand'], avoid: ['bed frame', 'bed base'] },
      { label: 'Bed linen', department: 'lighting-decor', cat: 'home-textiles', prefer: ['sheet', 'quilt cover', 'linen', 'bedding', 'duvet'], avoid: ['curtain', 'towel'] },
    ],
  },
  dining: {
    key: 'dining',
    label: 'Dining',
    title: 'A dining space, matched for you',
    intro: "A table, seating, the tableware to set it and a light overhead — one matched set to pull the dining space together. Swap any piece; you buy each one direct.",
    seeAll: { to: '/products/furniture', label: "See more dining products we've matched" },
    needs: [
      { label: 'Dining table', department: 'furniture', cat: 'dining-furniture', prefer: ['dining table', 'table'], avoid: ['chair', 'bench', 'stool', 'side table'] },
      { label: 'Seating', department: 'furniture', cat: 'dining-furniture', prefer: ['dining chair', 'chair', 'bench', 'stool'], avoid: ['table'] },
      { label: 'Tableware', department: 'kitchen-dining', cat: 'tableware-dining', prefer: ['dinner set', 'plate', 'glass', 'cutlery', 'bowl'], avoid: ['sample'] },
      { label: 'Pendant light', department: 'lighting-decor', cat: 'lighting-indoor', prefer: ['pendant', 'chandelier', 'ceiling'], avoid: ['bulb', 'globe', 'spare', 'part'] },
    ],
  },
  outdoor: {
    key: 'outdoor',
    label: 'Outdoors',
    title: 'Your outdoors, matched for you',
    intro: "Somewhere to sit, shade overhead, warmth for the evenings and a little light — one matched set to make the backyard usable. Swap any piece; you buy each one direct.",
    seeAll: { to: '/products/outdoor-garden', label: "See more outdoor products we've matched" },
    needs: [
      { label: 'Outdoor setting', department: 'outdoor-garden', cat: 'outdoor-furniture', prefer: ['setting', 'set', 'lounge', 'sofa', 'table'], avoid: ['cover', 'part', 'cushion only'] },
      { label: 'Shade & structure', department: 'outdoor-garden', cat: 'outdoor-structures', prefer: ['umbrella', 'gazebo', 'pergola', 'canopy', 'shade'], avoid: ['part', 'cover', 'weight', 'base only'] },
      { label: 'Warmth & comfort', department: 'outdoor-garden', cat: 'outdoor-comfort', prefer: ['heater', 'fire', 'cushion', 'rug'], avoid: ['part', 'cover'] },
      { label: 'Outdoor lighting', department: 'outdoor-garden', cat: 'lighting-outdoor', prefer: ['string', 'festoon', 'solar', 'lantern', 'light'], avoid: ['bulb', 'globe', 'spare', 'part'] },
    ],
  },
};

export const ROOM_ORDER = ['living', 'bedroom', 'dining', 'outdoor'];

// Which room a finishing project most naturally completes, used to pick the
// opening tab on the personalised workspace module.
const PROJECT_ROOM = {
  'swimming-pools': 'outdoor',
  'decking': 'outdoor',
  'landscaping': 'outdoor',
  'verandahs-pergolas': 'outdoor',
  'sheds-garages': 'outdoor',
};

export const roomForProject = (slug) => PROJECT_ROOM[slug] || 'living';
